"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filteredItems = exports.splitList = void 0;
// split a given list into `numColumns` lists of equal length
function splitList(list, numColumns, truncateAt = Infinity) {
    const listLength = list.length;
    const colLength = Math.ceil(listLength / numColumns);
    const lists = [];
    let start = 0;
    do {
        lists.push(list.slice(start, colLength + start));
        start = start + colLength;
    } while (start < listLength);
    if (truncateAt < Infinity) {
        const truncatePerList = Math.ceil(truncateAt / numColumns);
        return lists.map((list) => list.slice(0, truncatePerList));
    }
    return lists;
}
exports.splitList = splitList;
// filter the list of items based on the provided term
function filteredItems(items, term = '') {
    if (!term) {
        return items;
    }
    const trimmedTerm = term.trim().toLowerCase();
    return items.filter((item) => matchOnName(item, trimmedTerm) || matchOnAlias(item, trimmedTerm));
}
exports.filteredItems = filteredItems;
// checks if a given term matches an item's name
function matchOnName(item = { name: '' }, term = '') {
    return item.name.toLowerCase().includes(term);
}
// checks if a given term is found in an item's aliases
function matchOnAlias(item = { name: '' }, term = '') {
    const { aliases = [] } = item;
    return aliases.some((alias) => {
        return alias.toLowerCase().includes(term);
    });
}
//# sourceMappingURL=utils.js.map